'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _makeResourceTypeReducer = require('../../utils/services/http/resources/reducers/makeResourceTypeReducer');

var _makeResourceTypeReducer2 = _interopRequireDefault(_makeResourceTypeReducer);

var _elementHelper = require('../../../common/elements/elementHelper');

var _resourceConstants = require('../../utils/services/http/resources/resourceConstants');

var _elementConstants = require('../../../common/elements/elementConstants');

var _socketConstants = require('../../utils/socket/socketConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
var boardsPredicateFn = function boardsPredicateFn(action) {
    return action.resource === _resourceConstants.RESOURCE_TYPES.boards || action.type === _elementConstants.ELEMENT_CREATE && (0, _elementHelper.isBoard)(action.elementType) || action.type === _socketConstants.SOCKET_DISCONNECT;
};

// Constants
// Reducers
exports.default = (0, _makeResourceTypeReducer2.default)(_resourceConstants.RESOURCE_TYPES.boards, boardsPredicateFn);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/boardsResourceTypeReducer.js
// module id = 1956
// module chunks = 0